import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { MermaidRenderer } from './MermaidRenderer'

export function MdTextMarkdownBody({
  markdown,
  singleColumn = false,
  contentRef,
}: {
  markdown: string
  singleColumn?: boolean
  contentRef?: React.RefObject<HTMLDivElement>
}) {
  return (
    <div
      ref={contentRef}
      style={singleColumn ? { columns: 1 } : undefined}
      className="md-text-component__content prose prose-sm max-w-none gap-10 dark:prose-invert"
    >
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          pre({ children, ...props }) {
            const codeElement = children as React.ReactElement
            if (codeElement?.props?.className?.includes('language-mermaid')) {
              return <MermaidRenderer chart={String(codeElement.props.children).replace(/\n$/, '')} />
            }
            return <pre {...props}>{children}</pre>
          },
          code({ className, children, ...props }) {
            return (
              <code className={className} {...props}>
                {children}
              </code>
            )
          },
        }}
      >
        {markdown}
      </Markdown>
    </div>
  )
}
